export const FYI_TRANSLATION_KEYS = {
  HEADING_TEXT_SKIPASS: "[FYI_HEADING_TEXT_SKIPASS]",
  TEXT_SKIPASS_STEP_ONE: "[FYI_TEXT_SkiPass_STEP_One]",
  TEXT_SKIPASS_STEP_TWO: "[FYI_TEXT_SkiPass_STEP_Two]",
  INDUSTRY_RULES: "[FYI_INDUSTRYRULES]",
  INDUSTRY_RULES_URL: "[SKIPASS_INDUSTRY_RULES_URL]",
} as const

export type FyiTranslationKey =
  (typeof FYI_TRANSLATION_KEYS)[keyof typeof FYI_TRANSLATION_KEYS]
